import { StateModalComponent } from "@/interfaces/modelos";

export const getSelectedModal = (state: StateModalComponent) => {
  return state.selectedModal;
};
